module.exports = __webpack_public_path__ + "static/media/image5.7d932d34.png";